"use client";

import {
  getAllUSDTReferral,
  updateReferralUsdtApproval,
} from "../../variables/action";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FiCopy } from "react-icons/fi";
import "../../assets/css/usdt-claim.css";
import { Container } from "reactstrap";

export default function Table() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("pending");

  // Fetch referrals
  useEffect(() => {
    async function fetchReferrals() {
      try {
        setLoading(true);
        const res = await getAllUSDTReferral(page, limit, search, activeTab);
        console.log("res..", res);

        setData(res.data);
        setTotalPages(res.pagination.totalPages || 1);
      } catch (error) {
        toast.error("Failed to load referrals");
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    fetchReferrals();
  }, [page, limit, search, activeTab]);

  // Copy wallet to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => toast.success("Copied!"))
      .catch(() => toast.error("Failed to copy!"));
  };

  // Shorten wallet address
  const shortenString = (str) => {
    if (!str) return "";
    return `${str.substring(0, 6)}...${str.substring(str.length - 4)}`;
  };

  // Format date
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString();
  };

  // Approve referral
  const handleApprove = async (referralId) => {
    setLoading(true);
    try {
      const result = await updateReferralUsdtApproval(referralId, true);
      if (result.success) {
        toast.success("Referral approved successfully!");
        setData((prev) =>
          prev.map((ref) =>
            ref._id === referralId ? { ...ref, isApprove: true } : ref,
          ),
        );
      } else {
        toast.error(result.error || "Failed to approve referral");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error approving referral");
    } finally {
      setLoading(false);
    }
  };
  console.log(data);

  // return (
  //   <div className="bg-[#02080E] w-full mx-auto overflow-x-auto">
  //     <div className="rounded-xl shadow-lg overflow-hidden min-w-[800px] md:min-w-0">
  //       <div className="overflow-x-auto">
  //         {/* Search + Tabs */}
  //         <div className="flex flex-col md:flex-row justify-between items-start md:items-center p-4 bg-gray-900 gap-4">
  //           <input
  //             type="text"
  //             placeholder="Search by wallet..."
  //             value={search}
  //             onChange={(e) => {
  //               setSearch(e.target.value);
  //               setPage(1);
  //             }}
  //             className="px-3 py-2 rounded-md bg-gray-800 text-white placeholder-gray-400 w-full md:w-auto"
  //           />

  //           <div className="flex gap-2 w-full md:w-auto">
  //             <button
  //               onClick={() => {
  //                 setActiveTab("pending");
  //                 setPage(1);
  //               }}
  //               className={`px-3 py-2 rounded flex-1 md:flex-initial ${
  //                 activeTab === "pending"
  //                   ? "bg-[#6DAE1C] text-black"
  //                   : "bg-gray-700 text-white"
  //               }`}
  //             >
  //               Pending
  //             </button>
  //             <button
  //               onClick={() => {
  //                 setActiveTab("approved");
  //                 setPage(1);
  //               }}
  //               className={`px-3 py-2 rounded flex-1 md:flex-initial ${
  //                 activeTab === "approved"
  //                   ? "bg-[#6DAE1C] text-black"
  //                   : "bg-gray-700 text-white"
  //               }`}
  //             >
  //               Approved
  //             </button>
  //           </div>
  //         </div>

  //         {/* Loading */}
  //         {loading ? (
  //           <div className="flex justify-center items-center py-10">
  //             <div className="w-10 h-10 border-4 border-gray-300 border-t-[#6DAE1C] rounded-full animate-spin"></div>
  //           </div>
  //         ) : data.length === 0 ? (
  //           <div className="text-center py-10 text-gray-400">
  //             No referral records found.
  //           </div>
  //         ) : (
  //           <table className="min-w-full">
  //             <thead>
  //               <tr className="bg-gray-900">
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Referrer Wallet
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Referred Wallet
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Earning (USD)
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Claimed (USD)
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Created At
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Status
  //                 </th>
  //                 <th className="py-4 px-4 md:px-6 text-left text-white">
  //                   Action
  //                 </th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {data.map((referral, index) => (
  //                 <tr
  //                   key={referral._id}
  //                   className={index % 2 === 0 ? "bg-gray-800" : "bg-gray-700"}
  //                 >
  //                   {/* Referrer */}
  //                   <td className="py-4 px-4 md:px-6">
  //                     <div className="flex items-center gap-2">
  //                       <span>{shortenString(referral.referrer_wallet)}</span>
  //                       <button
  //                         onClick={() =>
  //                           copyToClipboard(referral.referrer_wallet)
  //                         }
  //                         className="text-gray-400 hover:text-[#6DAE1C]"
  //                       >
  //                         <FiCopy className="w-4 h-4" />
  //                       </button>
  //                     </div>
  //                   </td>

  //                   {/* Referred */}
  //                   <td className="py-4 px-4 md:px-6">
  //                     <div className="flex items-center gap-2">
  //                       <span>{shortenString(referral.referred_wallet)}</span>
  //                       <button
  //                         onClick={() =>
  //                           copyToClipboard(referral.referred_wallet)
  //                         }
  //                         className="text-gray-400 hover:text-[#6DAE1C]"
  //                       >
  //                         <FiCopy className="w-4 h-4" />
  //                       </button>
  //                     </div>
  //                   </td>

  //                   {/* Earnings */}
  //                   <td className="py-4 px-4 md:px-6 font-medium text-green-600">
  //                     ${referral.earning}
  //                   </td>

  //                   {/* Claimed */}
  //                   <td className="py-4 px-4 md:px-6 font-medium text-blue-500">
  //                     ${referral.claimed}
  //                   </td>

  //                   {/* Created At */}
  //                   <td className="py-4 px-4 md:px-6">
  //                     {formatDate(referral.createdAt)}
  //                   </td>

  //                   {/* Status */}
  //                   <td className="py-4 px-4 md:px-6">
  //                     {referral.isApprove ? (
  //                       <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
  //                         Approved
  //                       </span>
  //                     ) : (
  //                       <span className="px-2 py-1 rounded-full text-xs bg-red-100 text-red-800">
  //                         Pending
  //                       </span>
  //                     )}
  //                   </td>

  //                   {/* Action */}
  //                   <td className="py-4 px-4 md:px-6">
  //                     {referral.isApprove ? (
  //                       <span className="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
  //                         Approved
  //                       </span>
  //                     ) : (
  //                       <button
  //                         onClick={() => handleApprove(referral._id)}
  //                         disabled={Number(referral.earning) === 0}
  //                         className={`px-3 py-1 rounded-md text-sm font-medium ${
  //                           Number(referral.earning) === 0
  //                             ? "bg-gray-500 text-gray-300 cursor-not-allowed"
  //                             : "bg-[#6DAE1C] text-black hover:bg-[#6DAE1C]"
  //                         }`}
  //                       >
  //                         Approve
  //                       </button>
  //                     )}
  //                   </td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //         )}
  //       </div>

  //       {/* Pagination */}
  //       {!loading && data.length > 0 && (
  //         <div className="p-4 bg-gray-900 flex flex-col md:flex-row justify-between items-center gap-4">
  //           <span className="text-sm text-white">
  //             Page {page} of {totalPages}
  //           </span>
  //           <div className="flex gap-2 text-gray-800">
  //             <button
  //               onClick={() => setPage((p) => Math.max(1, p - 1))}
  //               disabled={page === 1}
  //               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
  //             >
  //               Prev
  //             </button>
  //             <button
  //               onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
  //               disabled={page === totalPages}
  //               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
  //             >
  //               Next
  //             </button>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   </div>
  // );
  return (
    <Container
      style={{
        border: "none",
        backgroundColor: "rgba(1,1,1,0.2)",
        padding: "0",
        maxWidth: "100%",
        paddingTop: "100px",
      }}
    >
      {" "}
      <div className="usdt-container">
        <div className="usdt-table-wrapper">
          <div className="usdt-scroll">
            {/* Search + Tabs */}
            <div className="usdt-header">
              <input
                type="text"
                placeholder="Search by wallet..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                className="usdt-search"
              />

              <div className="usdt-tabs">
                <button
                  onClick={() => {
                    setActiveTab("pending");
                    setPage(1);
                  }}
                  className={`usdt-tab ${
                    activeTab === "pending" ? "active" : ""
                  }`}
                >
                  Pending
                </button>
                <button
                  onClick={() => {
                    setActiveTab("approved");
                    setPage(1);
                  }}
                  className={`usdt-tab ${
                    activeTab === "approved" ? "active" : ""
                  }`}
                >
                  Approved
                </button>
              </div>
            </div>

            {/* Loading */}
            {loading ? (
              <div className="usdt-loading">
                <div className="usdt-spinner"></div>
              </div>
            ) : data.length === 0 ? (
              <div className="usdt-empty">No referral records found.</div>
            ) : (
              <table className="usdt-table">
                <thead>
                  <tr>
                    <th>Referrer Wallet</th>
                    <th>Referred Wallet</th>
                    <th>Earning (USD)</th>
                    <th>Claimed (USD)</th>
                    <th>Created At</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((referral, index) => (
                    <tr
                      key={referral._id}
                      className={index % 2 === 0 ? "even" : "odd"}
                    >
                      {/* Referrer */}
                      <td>
                        <div className="usdt-wallet">
                          <span>{shortenString(referral.referrer_wallet)}</span>
                          <button
                            onClick={() =>
                              copyToClipboard(referral.referrer_wallet)
                            }
                            className="usdt-copy-btn"
                          >
                            <FiCopy className="usdt-copy-icon" />
                          </button>
                        </div>
                      </td>

                      {/* Referred */}
                      <td>
                        <div className="usdt-wallet">
                          <span>{shortenString(referral.referred_wallet)}</span>
                          <button
                            onClick={() =>
                              copyToClipboard(referral.referred_wallet)
                            }
                            className="usdt-copy-btn"
                          >
                            <FiCopy className="usdt-copy-icon" />
                          </button>
                        </div>
                      </td>

                      {/* Earnings */}
                      <td className="text-green">${referral.earning}</td>

                      {/* Claimed */}
                      <td className="text-blue">${referral.claimed}</td>

                      {/* Created At */}
                      <td>{formatDate(referral.createdAt)}</td>

                      {/* Status */}
                      <td>
                        {referral.isApprove ? (
                          <span className="status approved">Approved</span>
                        ) : (
                          <span className="status pending">Pending</span>
                        )}
                      </td>

                      {/* Action */}
                      <td>
                        {referral.isApprove ? (
                          <span className="status approved">Approved</span>
                        ) : (
                          <button
                            onClick={() => handleApprove(referral._id)}
                            disabled={Number(referral.earning) === 0}
                            className={`usdt-approve-btn ${
                              Number(referral.earning) === 0 ? "disabled" : ""
                            }`}
                          >
                            Approve
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          {/* Pagination */}
          {!loading && data.length > 0 && (
            <div className="usdt-pagination">
              <span>
                Page {page} of {totalPages}
              </span>
              <div className="usdt-pagination-buttons">
                <button
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
                >
                  Prev
                </button>
                <button
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>{" "}
    </Container>
  );
}
